import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "src/dm/utils/axios";
import { APIS } from "src/dm/utils/constants";
import {
  DealPromoGroup,
  DealPromoGroupWriteRequest,
} from "src/dm/interfaces/DealPromoGroup";

interface Envelope {
  items: DealPromoGroup[];
  total: number;
}

const queryKey = (dealId: number | undefined) => ["deal-promo-groups", dealId];

export const useDealPromoGroups = (dealId: number | undefined) =>
  useQuery({
    queryKey: queryKey(dealId),
    enabled: dealId !== undefined && dealId > 0,
    queryFn: async (): Promise<DealPromoGroup[]> => {
      const response = await apiClient.get<Envelope>(
        `${APIS.Deals}/${dealId}/promo-groups`
      );
      return response.data.items;
    },
  });

export const useUpdateDealPromoGroup = (dealId: number | undefined) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: {
      promoGroupId: number;
      request: DealPromoGroupWriteRequest;
    }): Promise<DealPromoGroup> => {
      const response = await apiClient.put<DealPromoGroup>(
        `${APIS.Deals}/${dealId}/promo-groups/${vars.promoGroupId}`,
        vars.request
      );
      return response.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKey(dealId) });
    },
  });
};
